import React from 'react';
import { motion } from 'framer-motion';
interface HeroSectionProps {
  handlePurchase: () => void;
}
export function HeroSection({
  handlePurchase
}: HeroSectionProps) {
  return <header className="px-4 sm:px-[5%] py-12 sm:py-20 flex justify-center items-center min-h-[auto] sm:min-h-[80vh] relative overflow-hidden" data-id="element-84">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-[50px] items-center w-full max-w-[1200px] relative z-10" data-id="element-85">
        {/* Mockup Visual */}
        <div className="relative flex justify-center order-2 lg:order-1" data-id="element-86">
          <div className="absolute inset-0 bg-[radial-gradient(circle,rgba(212,175,55,0.18)_0%,transparent_70%)] scale-150 z-0 top-[-10%]" data-id="element-87" />
          <motion.img src="https://cdn.magicpatterns.com/uploads/s4KREQaaKCXAen2KiC2Baq/ChatGPT_Image_5_abr_2026,_03_38_29_p.m..png" alt="Manual Maestro del Código 888" className="w-full max-w-[280px] sm:max-w-[350px] lg:max-w-[450px] rounded-xl shadow-[0_40px_80px_rgba(0,0,0,0.9)] relative z-10" animate={{
          y: [0, -12, 0]
        }} transition={{
          duration: 6,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-88" />
        </div>

        {/* Texto de Ventas Hero */}
        <motion.div className="text-center lg:text-left order-1 lg:order-2" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-89">
          <span className="inline-block bg-gold/10 text-gold px-4 py-1.5 rounded-full text-[10px] sm:text-xs font-extrabold tracking-wider mb-4 sm:mb-6" data-id="element-90">
            OFERTA DE LANZAMIENTO LIMITADA
          </span>

          <h1 className="font-serif text-[32px] sm:text-[40px] lg:text-[56px] leading-[1.1] font-black mb-4 sm:mb-6" data-id="element-91">
            PROGRAMACIÓN <br data-id="element-92" />
            <span className="text-gold" data-id="element-93">NEURO-CUÁNTICA</span>
          </h1>

          <p className="text-base sm:text-lg opacity-80 leading-[1.6] mb-8 sm:mb-10 max-w-xl mx-auto lg:mx-0" data-id="element-94">
            Re-cablea tu cerebro para la abundancia en 15 minutos. Protocolo
            Maestro 888.
          </p>

          <button onClick={handlePurchase} className="bg-gold text-dark border-none py-4 sm:py-5 px-6 sm:px-8 text-base sm:text-lg font-black rounded cursor-pointer transition-all duration-300 shadow-[0_15px_35px_rgba(212,175,55,0.3)] w-full max-w-[400px] hover:scale-[1.03] hover:bg-[#f1c40f]" data-id="element-95">
            <span data-id="element-96">DESCARGAR AHORA — $6.39</span>
          </button>

          <p className="text-[10px] sm:text-xs text-gold font-bold mt-4 sm:mt-5 tracking-[2px]" data-id="element-97">
            ⚡ ACCESO INMEDIATO • PAGO ÚNICO
          </p>
        </motion.div>
      </div>
    </header>;
}